<template>
  <div class="addOnTrainingChaper max-w-[849px] mx-auto px-5 md:px-0">
    <h2 class="fluid-lg font-light leading-normal">{{ heading }} ({{ routinesList.length }})</h2>
    <div class="text-copy mt-4 text-[18px]" v-html="body"></div>
    <div class="flex flex-col lg:flex-row mt-10 -mx-4 flex-wrap">
      <div v-for="routine in routinesList" :key="routine.id" class="w-full lg:w-1/2 px-4 pb-8 lg:pb-20 flex">
        <RoutinePreview class="flex w-full" :routine="routine" />
      </div>
    </div>
  </div>
</template>

<script>
import RoutinePreview from '@/components/exercises/RoutinePreview';

export default defineNuxtComponent({
  name: 'AddOnTrainingChapter',
  components: {
    RoutinePreview,
  },
  props: {
    heading: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: null,
    },
    routines: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    routinesList() {
      return this.routines.filter((value) => Object.keys(value).length !== 0);
    },
  },
});
</script>
